<template>
  <custom-dialog :width="dialogWidth" :title="model.title || titleDic[model.changeType]" :visible="visible" append-to-body v-on="$listeners">
    <div class="dialog-body">
      <!-- 合同类申请 -->
      <contract-change-device v-if="showVisible === 'change_order_device'" ref="change_order_device" :model="modelData" @close="visible = false" @success="onSuccess"></contract-change-device>
      <contract-change-sale-device
        v-if="showVisible === 'change_order_sale_device'"
        ref="change_order_sale_device"
        :model="modelData"
        @close="visible = false"
        @success="onSuccess"
      ></contract-change-sale-device>
      <contract-change-afterservice
        v-if="showVisible === 'change_order_after_service'"
        ref="change_order_after_service"
        :model="modelData"
        @close="visible = false"
        @success="onSuccess"
      ></contract-change-afterservice>
      <contract-change-payment
        v-if="showVisible === 'change_order_payment_period'"
        ref="change_order_payment_period"
        :model="modelData"
        @close="visible = false"
        @success="onSuccess"
      ></contract-change-payment>
      <contract-change-startdate
        v-if="showVisible === 'change_order_rent_time'"
        ref="change_order_rent_time"
        :model="modelData"
        :unlimited="model.unlimited"
        @close="visible = false"
        @success="onSuccess"
      ></contract-change-startdate>
      <contract-stop-rent v-if="showVisible === 'change_order_stop_rent'" ref="change_order_stop_rent" :model="modelData" @close="visible = false" @success="onSuccess"></contract-stop-rent>
      <contract-stop-sale v-if="showVisible === 'change_order_stop_sale'" ref="change_order_stop_sale" :model="modelData" @close="visible = false" @success="onSuccess"></contract-stop-sale>
      <contract-stop-contract
        v-if="showVisible === 'change_order_stop_contract'"
        ref="change_order_stop_contract"
        :model="modelData"
        @close="visible = false"
        @success="onSuccess"
      ></contract-stop-contract>
      <contract-suspend-use v-if="showVisible === 'change_order_pause_use'" ref="change_order_pause_use" :model="modelData" @close="visible = false" @success="onSuccess"></contract-suspend-use>
      <contract-end-suspend-use
        v-if="showVisible === 'change_order_end_pause_use'"
        ref="change_order_end_pause_use"
        :model="modelData"
        @close="visible = false"
        @success="onSuccess"
      ></contract-end-suspend-use>
      <contract-stop-test v-if="showVisible === 'change_order_stop_test'" ref="change_order_stop_test" :model="modelData" @close="visible = false" @success="onSuccess"></contract-stop-test>
      <!-- 财务类申请 -->
      <invoice-apply v-if="showVisible === 'invoice'" ref="invoice" :model="modelData" @close="visible = false" @success="onSuccess"></invoice-apply>
      <invoice-gored v-if="showVisible === 'red_application'" ref="red_application" :model="modelData" @close="visible = false" @success="onSuccess"></invoice-gored>
      <invoice-delay-receive v-if="showVisible === 'deferred'" ref="deferred" :canAddPayableOrder="true" :model="modelData" @close="visible = false" @success="onSuccess"></invoice-delay-receive>
      <invoice-rovoke-receive v-if="showVisible === 'withdrawal_payment'" ref="withdrawal_payment" :model="modelData" @close="visible = false" @success="onSuccess"></invoice-rovoke-receive>
      <invoice-deposit-refund v-if="showVisible === 'deposit_refund'" ref="deposit_refund" :model="modelData" @close="visible = false" @success="onSuccess"></invoice-deposit-refund>
      <invoice-deposit-refund v-if="showVisible === 'jv_deposit_refund'" ref="jv_deposit_refund" :model="modelData" @close="visible = false" @success="onSuccess"></invoice-deposit-refund>
      <invoice-deposit-refund v-if="showVisible === 'hq_deposit_refund'" ref="hq_deposit_refund" :model="modelData" @close="visible = false" @success="onSuccess"></invoice-deposit-refund>
      <invoice-change-state v-if="showVisible === 'change_bill_trade_state'" ref="change_bill_trade_state" :model="modelData" @close="visible = false" @success="onSuccess"></invoice-change-state>
      <!-- 库存调拨-库存调拨申请单 -->
      <transfer-order-apply v-if="showVisible === 'transfer_order'" ref="transfer_order" :model="modelData" @close="visible = false" @success="onSuccess"></transfer-order-apply>
      <!-- 库存管理-库存延期申请 -->
      <change-stock-order-apply v-if="showVisible === 'change_stock_order'" ref="change_stock_order" :model="modelData" @close="visible = false" @success="onSuccess"></change-stock-order-apply>
      <!-- 库存管理-翻新申请 -->
      <change-stock-refurbish
        v-if="showVisible === 'return_hq_renovate_apply'"
        ref="return_hq_renovate_apply"
        :model="modelData"
        @close="visible = false"
        @success="onSuccess"
      ></change-stock-refurbish>
      <!-- 试用费 - 申请免收 -->
      <apply-free v-if="showVisible === 'free_test_fee'" ref="free_test_fee" :model="modelData" @close="visible = false" @success="onSuccess"></apply-free>
      <!-- 库存管理-申请免收 -->
      <apply-free v-if="showVisible === 'free_stock_fee'" ref="free_stock_fee" :model="modelData" @close="visible = false" @success="onSuccess"></apply-free>
      <!-- 逾期费-申请免收 -->
      <apply-free v-if="showVisible === 'free_overdue_fee'" ref="free_overdue_fee" :model="modelData" @close="visible = false" @success="onSuccess"></apply-free>
      <!-- 违约金 -申请免收 -->
      <apply-free v-if="showVisible === 'free_break_fee'" ref="free_break_fee" :model="modelData" @close="visible = false" @success="onSuccess"></apply-free>
      <!--dms-设备报废 device_scrap-->
      <device-scrap v-if="showVisible === 'device_scrap'" ref="device_scrap" :model="modelData" @close="visible = false" @success="onSuccess"></device-scrap>
      <!--crm-购买数据服务 buy_data_service-->
      <device-buy-service v-if="showVisible === 'buy_data_service'" ref="buy_data_service" :model="modelData" @close="visible = false" @success="onSuccess"></device-buy-service>
      <!--asm- modem_service-->
      <offline-service v-if="showVisible === 'modem_service'" ref="modem_service" :model="modelData" @close="visible = false" @success="onSuccess"></offline-service>
      <!--asm 质量反馈 feedBack -->
      <feed-back v-if="showVisible === 'feed_back'" ref="feed_back" :model="modelData" @close="visible = false" @success="onSuccess"></feed-back>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="model.type !== 'watch'" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button v-repeat="5000" v-if="model.type !== 'watch' && !notDraftArr.includes(showVisible)" type="primary" @click="onConfirm()">{{ $t('components_approval_dialog.bao_cun_cao_gao') }}</el-button>
      <el-button v-repeat="5000" type="primary" @click="onConfirm(1)">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins.js';
import deviceScrap from '@/components/approvalCenter/device_scrap';
import deviceBuyService from '@/components/approvalCenter/device_buy_service';
import offlineService from '@/components/approvalCenter/offline_service';
import contractChangeDevice from './contract_change_device.vue';
import contractChangeSaleDevice from './contract_change_sale_device.vue';
import contractChangeAfterservice from './contract_change_afterservice.vue';
import contractChangeStartdate from './contract_change_startdate.vue';
import contractChangePayment from './contract_change_payment.vue';
import contractStopContract from './contract_stop_contract.vue';
import contractStopRent from './contract_stop_rent.vue';
import contractStopSale from './contract_stop_sale.vue';
import contractSuspendUse from './contract_suspend_use.vue';
import contractEndSuspendUse from './contract_end_suspend_use.vue';
import contractStopTest from './contract_stop_test.vue';
import invoiceApply from './invoice_apply.vue';
import invoiceGored from './invoice_gored.vue';
import invoiceChangeState from './invoice_change_state.vue';
import invoiceDelayReceive from './invoice_delay_receive.vue';
import invoiceRovokeReceive from './invoice_revoke_receive.vue';
import transferOrderApply from './transfer_order_apply.vue';
import changeStockOrderApply from './change_stock_order_apply';
import changeStockRefurbish from './change_stock_refurbish';
import invoiceDepositRefund from './invoice_deposit_refund.vue';
import feedBack from './feed_back';
import applyFree from './apply_free';

export default {
  mixins: [dialogMixins],
  components: {
    contractChangeDevice,
    contractChangeSaleDevice,
    contractChangeAfterservice,
    contractChangePayment,
    contractChangeStartdate,
    contractStopRent,
    contractStopSale,
    contractStopContract,
    contractSuspendUse,
    contractEndSuspendUse,
    contractStopTest,
    invoiceApply,
    invoiceGored,
    invoiceChangeState,
    invoiceDelayReceive,
    invoiceRovokeReceive,
    transferOrderApply,
    invoiceDepositRefund,
    changeStockOrderApply,
    changeStockRefurbish,
    applyFree,
    deviceScrap,
    deviceBuyService,
    offlineService,
    feedBack,
    // stockCancelCollection,
  },
  props: {
    unlimited: { type: Boolean, default: false },
    dialogWidth: {
      type: String,
      default: '92%',
    },
  },
  data() {
    return {
      provide: true,
      showVisible: '',
      modelData: {},
      titleDic: {},
      // 不展示草稿按钮的组件
      notDraftArr: ['change_stock_order', 'buy_data_service'],
    };
  },
  mounted() {
    this.getDictionary('approval_type', (data) => {
      this.titleDic = this.$listTransObject(data.approval_type, 'value', 'name');
    });
    this.showVisible = this.model.changeType; // 对应字典 approval_type
    const changeType = this.model.changeType;
    this.modelData = {
      ...this.model,
      changeType,
      approve: false, // 是否审批流中
      showProcess: false, // 是否审批通过，
      type: this.model.type, // edit、watch
      changeId: this.model.changeId, // 编辑查看（审批列表的bizId字段）
      row: this.model.row, // 附带其他数据
    };
  },
  methods: {
    // 保存提交
    onConfirm: function (data) {
      if (this.$refs[this.showVisible]) {
        this.$refs[this.showVisible].onConfirm(data);
      }
    },
    // 成功回调
    onSuccess: function () {
      this.$emit('success');
      this.visible = false;
    },
  },
};
</script>

<style lang="scss"></style>
